// src/dashboard/pages/teacher/Palmares/components/PalmaresMobileCards.jsx

import React from "react";
import { FaEdit, FaTrash } from "react-icons/fa";

import {
  formatDateFr,
  formatEventLabel,
  getAdherentFromPalmares,
  getAvatarSrc,
  getMemberDisplayName,
  getResolvedEventFromPalmares,
} from "../utils/palmaresDashboardUtils";

import VisibilitySwitch from "./VisibilitySwitch";

export default function PalmaresMobileCards({
  items = [],
  events = [],
  onEdit,
  onDelete,
  onToggleIsActive,
  deletingId,
  togglingId,
}) {
  return (
    <div className="space-y-3 md:hidden">
      {items.map((item) => {
        const adherent = getAdherentFromPalmares(item);
        const event = getResolvedEventFromPalmares(item, events);

        return (
          <article
            key={`mobile-${item.id}`}
            className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900/60"
          >
            <div className="p-3">
              <div className="flex items-start gap-3">
                <img
                  src={getAvatarSrc(adherent?.photo_url)}
                  alt={getMemberDisplayName(adherent)}
                  className="h-14 w-14 shrink-0 rounded-2xl object-cover ring-1 ring-slate-200 dark:ring-slate-700"
                  onError={(event) => {
                    event.currentTarget.src = "/img/user_avatar.jpg";
                  }}
                />

                <div className="min-w-0 flex-1">
                  <div className="flex items-start justify-between gap-2">
                    <div className="min-w-0">
                      <h3 className="truncate text-sm font-bold text-slate-900 dark:text-white">
                        {getMemberDisplayName(adherent)}
                      </h3>

                      <p className="mt-0.5 text-xs font-medium text-slate-500 dark:text-slate-400">
                        {formatDateFr(item.date_palmares)}
                      </p>
                    </div>

                    <VisibilitySwitch
                      checked={!!item.is_active}
                      disabled={togglingId === item.id}
                      onChange={() => onToggleIsActive(item.id)}
                    />
                  </div>

                  <div className="mt-3">
                    <p className="text-sm font-bold text-slate-900 dark:text-white">
                      {item.titre_palmares || "—"}
                    </p>

                    <div className="mt-2 flex flex-wrap gap-2">
                      {item.resultats_palmares ? (
                        <span className="inline-flex rounded-full bg-sky-50 px-2.5 py-1 text-[11px] font-bold text-sky-700 ring-1 ring-sky-200 dark:bg-sky-500/10 dark:text-sky-300 dark:ring-sky-500/20">
                          {item.resultats_palmares}
                        </span>
                      ) : null}

                      {item.classement_palmares ? (
                        <span className="inline-flex rounded-full bg-amber-50 px-2.5 py-1 text-[11px] font-bold text-amber-700 ring-1 ring-amber-200 dark:bg-amber-500/10 dark:text-amber-300 dark:ring-amber-500/20">
                          {item.classement_palmares}
                        </span>
                      ) : null}
                    </div>

                    {item.event_palmares_id ? (
                      <p className="mt-2 line-clamp-2 text-xs leading-5 text-slate-500 dark:text-slate-400">
                        Événement : {formatEventLabel(event)}
                      </p>
                    ) : null}

                    {item.observations_palmares ? (
                      <p className="mt-2 line-clamp-3 text-xs leading-5 text-slate-600 dark:text-slate-300">
                        {item.observations_palmares}
                      </p>
                    ) : null}
                  </div>

                  <div className="mt-3 flex items-center gap-2">
                    <button
                      type="button"
                      onClick={() => onEdit(item)}
                      className="inline-flex items-center justify-center gap-2 rounded-xl border border-slate-200 bg-white px-3 py-2 text-xs font-bold text-slate-700 transition hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200"
                    >
                      <FaEdit />
                      Modifier
                    </button>

                    <button
                      type="button"
                      onClick={() => onDelete(item)}
                      disabled={deletingId === item.id}
                      className="inline-flex items-center justify-center gap-2 rounded-xl border border-rose-200 bg-rose-50 px-3 py-2 text-xs font-bold text-rose-700 transition hover:bg-rose-100 disabled:opacity-50 dark:border-rose-500/20 dark:bg-rose-500/10 dark:text-rose-300"
                    >
                      <FaTrash />
                      Supprimer
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </article>
        );
      })}
    </div>
  );
}
